import apiAxios from '../api/apiAxios';

const BASE_URL = '/header2';

const Header2Service = {
    // Criar um novo Header2
    create: async (data) => {
        try {
            const response = await apiAxios.post(`${BASE_URL}/`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Listar todos os Headers2
    getAll: async () => {
        try {
            const response = await apiAxios.get(`${BASE_URL}/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Buscar um Header2 por ID
    getById: async (id) => {
        try {
            const response = await apiAxios.get(`${BASE_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Atualizar um Header2 por ID
    update: async (id, data) => {
        try {
            const response = await apiAxios.put(`${BASE_URL}/${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Deletar um Header2 por ID
    delete: async (id) => {
        try {
            const response = await apiAxios.delete(`${BASE_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }
};

export default Header2Service;
